export const BREAKPOINTS = {
  xs: 480,
  sm: 576,
  md: 768,
  lg: 1024,
  xl: 1200,
} as const;

/** For styled-components media queries */
export const media = {
  xs: `@media (max-width: ${BREAKPOINTS.xs}px)`,
  sm: `@media (max-width: ${BREAKPOINTS.sm}px)`,
  md: `@media (max-width: ${BREAKPOINTS.md}px)`,
  lg: `@media (max-width: ${BREAKPOINTS.lg}px)`,
  xl: `@media (max-width: ${BREAKPOINTS.xl}px)`,
  upMd: `@media (min-width: ${BREAKPOINTS.md + 1}px)`,
} as const;
